import React, { useMemo } from "react"
import { Radio, Input, Button, Flex } from "antd"
import { SearchOutlined } from "@ant-design/icons"
import { useNavigate, useSearchParams } from "react-router-dom"
import { getTimePeriods, REQUEST_TYPES } from "../constants"
import { useTranslation } from "react-i18next"
import styles from "./header.module.css"
import DateSwitcher from "modules/datepicker/DateSwitcher"
import PropTypes from "prop-types"
import { routes } from "router/routes"
import useActiveGuide from "hooks/useActiveClient"

const BookingsHeader = ({ onChangeFilters }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const timePeriod = getTimePeriods(t)
  const [searchParams] = useSearchParams()
  const range = searchParams.get("range")
  const type = searchParams.get("type")
  const search = searchParams.get("search")
  const currentDate = searchParams.get("date")
  let date = useMemo(() => (currentDate ? global.dateTime(currentDate) : null), [currentDate])
  const [active] = useActiveGuide()

  const restrictions = useMemo(() => {
    if (type === REQUEST_TYPES.upcoming) {
      const mindDate = global.dateTime().startOf(range === "day" ? "date" : range || "date", 1)
      date = currentDate
      return {
        minDate: mindDate
      }
    }
    date = currentDate
    return {}
  }, [type, range])

  return (
    <Flex gap={10} justify="space-between" align="center" wrap="wrap" className={styles.headerContainer}>
      <Radio.Group name="range" value={range} className={styles.radioButtonSwitch} onChange={onChangeFilters}>
        {Object.entries(timePeriod).map(([range, label]) => (
          <Radio.Button name="range" key={range} value={range} className={styles.radioButton} onChange={onChangeFilters}>
            {label}
          </Radio.Button>
        ))}
      </Radio.Group>

      <DateSwitcher
        className={styles.dateSwitcher}
        value={date}
        key={date}
        defaultValue={global.dateTime().startOf("date")}
        name="date"
        type={range}
        onChange={onChangeFilters}
        restrictions={restrictions}
      />

      <Flex align="center" className={`${styles.searchContainer}`} gap={10}>
        <Input
          prefix={<SearchOutlined aria-hidden="true" />}
          placeholder={t("bookings.search_bookings")}
          className={styles.searchInput}
          name="search"
          allowClear
          value={search || ""}
          onChange={onChangeFilters}
        />
        <Button
          disabled={!active}
          className={styles.addBookingBtn}
          type="primary"
          onClick={active ? () => navigate(routes.guideBookingNewPath()) : undefined}
        >
          {t("bookings.add")}
        </Button>
      </Flex>
    </Flex>
  )
}

BookingsHeader.propTypes = {
  onChangeFilters: PropTypes.func.isRequired
}

export default BookingsHeader
